<template>
  <modal
    title="Rappel SMS"
    :value="show"
    cancelText="Annuler"
    okText="Envoyer"
    effect="fade/zoom"
    @cancel="close"
  >
    <div
      v-show="showWarning"
      class="card card-inverse card-warning text-center"
      style="position: relative"
    >
      <div class="card-block">
        <blockquote class="card-blockquote">
          Avez-vous bien relancé par email auparavant ?
        </blockquote>
      </div>
      <i
        class="fa fa-times"
        style="position: absolute; top: 5px; right: 5px; cursor: pointer"
        @click="showWarning = false"
      ></i>
    </div>

    <div class="row mb-1">
      <div class="col-12">
        <el-switch
          v-model="select"
          active-text="Sélection"
          inactive-text="Tous"
        />
      </div>
    </div>

    <div v-if="select" class="row">
      <el-checkbox-group
        v-model="selected"
        class="col-12 d-flex flex-column"
        style="max-height: 500px; overflow-y: auto"
      >
        <el-checkbox
          v-for="option in coachOptions"
          :key="option.value"
          :label="option.value"
          >{{ option.label }}</el-checkbox
        >
      </el-checkbox-group>

      <div v-if="selected.length" class="col-12 mt-1">
        Envoyer un SMS de rappel aux {{ selected.length }} coach{{ selected.length > 1 ? "s" : "" }} sélectionné{{ selected.length > 1 ? "s" : "" }} ?
      </div>
    </div>

    <div v-else class="row">
      <div class="col-12">
        Envoyer un SMS de rappel à tous les {{ coachs.length }} coachs "en attente de réponse" ? <br />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="d-flex align-items-center">
            <label for="sms-message" style="margin-bottom: 0 !important"
              >Message SMS</label
            >
            <el-popover
              placement="top-start"
              :width="350"
              trigger="hover"
              :content="
                select
                  ? 'Le message ci-dessous est un aperçu de ce qui sera envoyé pour chaque coach. Seul [prénom] sera remplacé par le prénom de chaque coach. Si vous le modifiez, pensez à changer l\'endroit avec [prénom] ou modifiez complètement le message.'
                  : 'Le message ci-dessous sera envoyé tel quel s\'il n\'est pas modifié.'
              "
            >
              <span slot="reference" class="ml-1">
                <i class="fa fa-info-circle"></i>
              </span>
            </el-popover>
          </div>
          <button
            v-if="customMessage !== currentDefaultMessage"
            type="button"
            class="btn btn-sm btn-outline-secondary"
            @click="resetToDefault"
          >
            Réinitialiser
          </button>
        </div>
        <textarea
          id="sms-message"
          v-model="customMessage"
          class="form-control"
          rows="4"
        ></textarea>
        <div class="mt-1 d-flex justify-content-between align-items-center">
          <span
            :class="
              characterCount > 320
                ? 'text-danger'
                : characterCount > 160
                ? 'text-warning'
                : 'text-muted'
            "
          >
            {{ characterCount }}/160 caractères
          </span>
          <span
            v-if="characterCount > 160 && characterCount <= 320"
            class="text-warning"
          >
            Message envoyé en {{ priceMultiplier }} SMS
          </span>
          <span v-if="characterCount > 320" class="text-danger">
            Le message est trop long
          </span>
        </div>
      </div>
    </div>

    <div slot="modal-footer" class="modal-footer">
      <button type="button" class="btn btn-default" @click="close">
        Annuler
      </button>

      <button
        type="button"
        class="btn btn-primary"
        @click="sendReminder"
        :disabled="(select && !selected.length) || this.characterCount > 320"
      >
        Envoyer
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from "vue-strap/src/Modal";

export default {
  components: {
    Modal,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    coachs: {
      type: Array,
      default: () => [],
    },

    order: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      showWarning: true,
      select: false,
      selected: [],
      defaultMessageAll:
        'Bonjour, \n\nUn client correspond à vos critères !\n\nRendez-vous sur votre application Just Coaching, onglet "Attribution" pour valider ou refuser.\n\nSportivement, \n\nL\'équipe Just Coaching\nwww.justcoaching.fr',
      customMessage:
        'Bonjour, \n\nUn client correspond à vos critères !\n\nRendez-vous sur votre application Just Coaching, onglet "Attribution" pour valider ou refuser.\n\nSportivement, \n\nL\'équipe Just Coaching\nwww.justcoaching.fr',
    };
  },

  computed: {
    coachOptions() {
      return this.coachs
        .map((coach) => ({
          value: coach.email,
          label: `${coach.coach?.name || coach.email} (${
            coach.distance ? coach.distance.distance : "Hors secteur"
          })`,
          sort: coach.distanceSort || 0,
        }))
        .sort((a, b) => {
          if (!this.coachs.some((coach) => coach.distance)) {
            const nameA = a.label.toLowerCase();
            const nameB = b.label.toLowerCase();

            if (nameA > nameB) return 1;

            if (nameB > nameA) return -1;

            return 0;
          } else {
            return b.sort - a.sort;
          }
        });
    },

    defaultMessageSelection() {
      const city = this.order?.client?.city;
      const objectif = this.order?.client?.objectif;

      let details = "";

      if (city && objectif) {
        details = `à ${city} pour ${objectif}`;
      } else if (city) {
        details = `à ${city}`;
      } else if (objectif) {
        details = `pour ${objectif}`;
      }

      return `Bonjour [prénom], \n\nUne demande de coaching ${details}. Consulte ton appli, onglet "Attribution".`;
    },

    currentDefaultMessage() {
      return this.select
        ? this.defaultMessageSelection
        : this.defaultMessageAll;
    },

    currentMessage() {
      return this.customMessage;
    },

    characterCount() {
      return this.currentMessage.length;
    },

    priceMultiplier() {
      return Math.ceil(this.characterCount / 160);
    },
  },

  watch: {
    select() {
      if (
        this.customMessage === this.defaultMessageAll ||
        this.customMessage === this.defaultMessageSelection
      ) {
        this.customMessage = this.currentDefaultMessage;
      }
    },

    coachs() {
      this.select = false;
      this.selected = [];
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },

    resetToDefault() {
      this.customMessage = this.currentDefaultMessage;
    },

    sendReminder() {
      if (this.characterCount > 320) {
        return;
      }

      const messageToSend =
        this.customMessage === this.currentDefaultMessage
          ? null
          : this.customMessage;

      this.$emit(
        "send",
        this.select ? this.selected : this.coachs.map((c) => c.email),
        messageToSend,
        this.priceMultiplier,
        this.select
      );

      this.select = false;
      this.selected = [];
    },
  },
};
</script>
